import type { PropsWithChildren } from 'react';
import { PLACEHOLDERS } from '../../constants/pdf-preview.ts';
import { usePlaceholders } from '../placeholders-context.tsx';

export function MerchantInformationPlaceholder({ children }: PropsWithChildren): React.ReactNode {
  const { showPlaceholder } = usePlaceholders(PLACEHOLDERS.MerchantAddress);

  if (showPlaceholder) {
    return null;
  }

  return <>{children}</>;
}
